"use strict";

global.jQuery = require("jquery");

var mainModule = "openFin",
  angular = require("angular");

require("angular-sanitize");
require("angular-ui-bootstrap");
require("angular-ui-router");
require("restangular");
require("angular-http-auth");
require("redi-common-angular");

var deps = [
  "ngSanitize",
  "ui.router",
  "restangular",
  "ui.bootstrap",
  "http-auth-interceptor",
  "redi-common",
  require("redi-window-container-web-lib-angular"),
  require("redi-refdata-web-lib"),
  require("redi-idp-web-lib"),
  require("redi-workspaces-web-lib-angular")
];

/**
 * Main app module for OpenFin
 */
angular.module(mainModule, deps);
require("app/config")(angular, mainModule);
require("app/infrastructure")(angular, mainModule);
require("app/business")(angular, mainModule);
require("app/presentation")(angular, mainModule);
require("app/ui")(angular, mainModule);



// WEBPACK FOOTER //
// ./app.js